module.exports = __webpack_public_path__ + "static/img/gp-head-hbd@2x.55c3a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gp-head-hbd@2x.png
// module id = 342
// module chunks = 0